import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { Button } from '@aimsos/ui';

import { ArrowRight } from 'lucide-react';

/**
 * The line shared by the three Knowledge subtabs (CT-5717): "N facts in Truth ·
 * N due to re-confirm · No signed documents in Canon" and "View in Truth". The
 * counts are the Truth plane's (CT-5719). Nothing renders until they arrive.
 *
 * As in the prototype, what is due to re-confirm is a link (to Truth, where it is
 * re-confirmed) and "View in Truth →" sits on the right.
 */
const KnowledgeSummaryLine = memo(function KnowledgeSummaryLine({ summary, onViewTruth }) {
  const { t } = useTranslation('unified-profiles');

  if (!summary) return null;

  return (
    <div data-testid="knowledge-summary" className="flex flex-1 flex-wrap items-center gap-2 text-sm text-content-secondary">
      <span>{t('knowledge.summary.facts', { count: summary.factsCount })}</span>
      <span aria-hidden>·</span>
      {summary.dueToReconfirm && onViewTruth ? (
        <Button variant="ghost" size="sm" onClick={onViewTruth} className="!h-auto !px-0 underline underline-offset-2">
          {t('knowledge.summary.due', { count: summary.dueToReconfirm })}
        </Button>
      ) : (
        <span>{t('knowledge.summary.due', { count: summary.dueToReconfirm })}</span>
      )}
      <span aria-hidden>·</span>
      <span>
        {summary.canonSigned
          ? t('knowledge.summary.canon', { count: summary.canonSigned })
          : t('knowledge.summary.noCanon')}
      </span>
      {onViewTruth ? (
        <Button variant="ghost" size="sm" rightIcon={ArrowRight} onClick={onViewTruth} className="ml-auto">
          {t('knowledge.summary.viewTruth')}
        </Button>
      ) : null}
    </div>
  );
});

export default KnowledgeSummaryLine;
